import React, { useRef, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

const Navigation = () => {
  const [categories, setCategories] = useState([]);
  const menuRef = useRef(null);
  const navLinksRef = useRef(null);
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [activeCategoryId, setActiveCategoryId] = useState(null);

  // Gestion de la catégorie active (qui montre ses sous catégories ?) -> pour la gestion mobile
  const toggleSubMenu = (categoryId) => {
    setActiveCategoryId((prevId) =>
      prevId === categoryId ? null : categoryId
    );
  };

  // Gestion du menu hamburger
  useEffect(() => {
    const handleMenuClick = () => {
      setIsMenuVisible((prev) => !prev);
    };

    const handleScroll = () => {
      if (isMenuVisible) {
        setIsMenuVisible(false);
      }
    };

    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        navLinksRef.current &&
        !navLinksRef.current.contains(event.target)
      ) {
        setIsMenuVisible(false);
      }
    };

    const menuButton = menuRef.current;
    if (menuButton) {
      menuButton.addEventListener("click", handleMenuClick);
    }

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      if (menuButton) {
        menuButton.removeEventListener("click", handleMenuClick);
      }
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuVisible]);

  // Fetch des catégories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}fetch_cats.php`
        );
        if (!response.ok) {
          throw new Error("Erreur lors du chargement des catégories");
        }
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error("Erreur:", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <div>
      <div className="nav-container">
        <div className="nav-bar">
          <div className="logo">
            <NavLink to="/">
              <img
                src={`${process.env.REACT_APP_DATA_URL}/img/logo.jpg`}
                alt="Logo ELIZE SOKOLOVA"
                className="home-logo"
              />
            </NavLink>
          </div>
          <div
            className={`nav-links ${isMenuVisible ? "mobile-menu" : ""}`}
            ref={navLinksRef}
          >
            {categories.map((category) => (
              <div key={category.id} className="nav-link">
                <div className="category-with-toggle">
                  {isMenuVisible && category.subCategories?.length > 0 && (
                    <button
                      className="submenu-toggle"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleSubMenu(category.id);
                      }}
                    >
                      {activeCategoryId === category.id ? "–" : "+"}
                    </button>
                  )}

                  <NavLink
                    to={`/c/${category.id}`}
                    className="nav-category-link"
                    onClick={() => {
                      if (isMenuVisible) {
                        setIsMenuVisible(false);
                        setActiveCategoryId(null); // facultatif : refermer sous-menu actif
                      }
                    }}
                  >
                    {category.name}
                  </NavLink>
                </div>

                {category.subCategories?.length > 0 && (
                  <div
                    className={`nav-subLinks ${
                      isMenuVisible && activeCategoryId === category.id
                        ? "show"
                        : ""
                    }`}
                  >
                    {category.subCategories.map((subCategory) => (
                      <div key={subCategory.id}>
                        <NavLink
                          to={`/c/${category.id}/${subCategory.id}`}
                          className="nav-link-sub"
                          onClick={() => {
                            if (isMenuVisible) {
                              setIsMenuVisible(false);
                              setActiveCategoryId(null); // facultatif : refermer sous-menu actif
                            }
                          }}
                        >
                          {subCategory.name}
                        </NavLink>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <img
        src={`${process.env.REACT_APP_DATA_URL}/img/menu-btn.png`}
        alt="Menu"
        className={`menu-btn ${isMenuVisible ? "invert" : ""}`}
        ref={menuRef}
      />
    </div>
  );
};

export default Navigation;
